import CreateNewRequest from "../createNewRequest/createNewRequest";


const LandingPage = () => {
    return (
        <CreateNewRequest />
    )

}

export default LandingPage;